let host = 'https://h5.wewillpro.com/api';//测试
let willapi = 'https://willapi.wewillpro.com'
let capi = 'https://capi.wewillpro.com'
let tapi = 'https://tapi.wewillpro.cn'
let token = 'UWQCN1FrBWNRPgAwXCkIalU6Bz8NZ1Y8AToBMgYzVTdRZg'
let test_token = 'UGVaaAI6UzINago2C35RM1I9UGgLYARlDjAEMV1oBm9VZQ'
const config = {
    token,
    test_token,
    tapi,
    capi,
    website: capi+'/website',
    guangqi: capi+'/guangqi',
    collect_card:capi+'/collect_card'
}
//需要让外部拿到
export default config



// WEBPACK FOOTER //
// ./src/utils/api.js